// Single source of truth for which artwork set an advent-calendar event uses.
//
// Every advent event arrives from the backend with its own `uniqueIdentifier`,
// but several events reuse the same artwork, so identifiers map to a variant
// key instead of being matched individually in each component. A new event that
// reuses existing artwork is one line here rather than an edit in every view.
//
// Variant assets live in /public/images/adventCalendar as
// {title,default,current,special,claimed,glow}_{variant}.png; the 'default'
// variant uses the unsuffixed files.
const VARIANT_BY_IDENTIFIER = {
    'advent-calendar-march26': 'april',
    'advent-calendar-sept': 'sept',   // Maryland campaign, Sept 2025
    'advent-calendar-sept26': 'sept', // Sept 2026 reuses the Maryland artwork
    'advent-calendar-july26': 'july',
};

const LABEL_KEY_BY_VARIANT = {
    april: 'AdventCalendarApril',
    sept: 'AdventCalendarSept',
    july: 'AdventCalendarWorldCup',
    default: 'AdventCalendar',
};

export function adventVariant(uniqueIdentifier) {
    return VARIANT_BY_IDENTIFIER[uniqueIdentifier] ?? 'default';
}

export function adventLabelKey(uniqueIdentifier) {
    return LABEL_KEY_BY_VARIANT[adventVariant(uniqueIdentifier)];
}
